import React from 'react';
import './estilos.css';

export default class Persona extends React.Component{
  constructor(props){
    super(props);
  }

  render(){
    const {datos, seleccionado, seleccionar} = this.props;
    return(
      <div 
        className='Persona'
        style={{backgroundColor:seleccionado ? '#ffb895':'null'}}
        onClick={() => seleccionar()}
      >
        <span className='Documento'>{datos.documento}</span>
        <span>{`${datos.apellidos}, ${datos.nombres}`}</span>
        <span>{datos.localidad}</span>
      </div>
    )
  }
}